export default "__VITE_ASSET__DaUwQWST__"